import { useContext } from 'react'
import { AutoClaimContext } from '../contexts'

export const useAutoClaimContext = () => useContext(AutoClaimContext)
